import { gql } from "@apollo/client";

export const getAllRegisteredDogsByAdminQuery = gql`
  query GetAllRegisteredDogsByAdmin(
    $pageNumber: Int!
    $pageSize: Int!
    $search: String
  ) {
    getAllRegisteredDogsByAdmin(
      pageNumber: $pageNumber
      pageSize: $pageSize
      search: $search
    ) {
      pageNumber
      pageSize
      totalDocs
      totalPages
      totalCount
      data {
        id
        call_name
        registration_name
        owner_name
        email
        phone_number
        dateOfJoining
        status
        amount
        payment_status
        authId
      }
    }
  }
`;

export const updateRegisteredDogMarkPaidMutation = gql`
  mutation UpdateRegisteredDogMarkPaid(
    $dogId: String!
    $data: UpdateDogMarkPaidByAdminInput!
  ) {
    updateRegisteredDogMarkPaid(dogId: $dogId, data: $data) {
      message
    }
  }
`;
